import { fromJS } from "immutable";

import { bulkDeselectProductsActions } from "actions/bulkDeselectProductsActions.js";

const initialState = fromJS({
  isLoading: false,
  hasErrors: false,
  data: {
    success: null,
    message: null,
    filtered_products_count: null,
    existing_buyplan_items_count: null,
    imported_products_count: null,
    failed_products_count: null
  }
});

export default (state = initialState, action) => {
  const payload = action.payload;

  switch (action.type) {
    case bulkDeselectProductsActions.startLoader:
      return state.set("isLoading", true);
    case bulkDeselectProductsActions.success:
      return state
        .merge({
          hasErrors: false,
          isLoading: false
        })
        .set("data", fromJS(payload.data));
    case bulkDeselectProductsActions.failure:
      return state.merge({
        hasErrors: true,
        isLoading: false
      });
    case bulkDeselectProductsActions.reset:
      return initialState;
    default:
      return state;
  }
};
